The actual candidate process history item.
